export const GET_ALL_MARK = "GET_ALL_MARK";
export const GET_ALL_MARK_SUCCESS = "GET_ALL_MARK_SUCCESS";
export const GET_ALL_MARK_FAIL = "GET_ALL_MARK_FAIL";

// For Creating MARK
export const CREATE_MARK = "CREATE_MARK";
export const CREATE_MARK_SUCCESS = "CREATE_MARK_SUCCESS";
export const CREATE_MARK_FAIL = "CREATE_MARK_FAIL";

// For Updating State Data Status
export const UPDATE_MARK = "UPDATE_MARK";
export const UPDATE_MARK_SUCCESS = "UPDATE_MARK_SUCCESS";
export const UPDATE_MARK_FAIL = "UPDATE_MARK_FAIL";

export const UPDATE_STATUS_MARK = "UPDATE_STATUS_MARK";
export const UPDATE_STATUS_MARK_SUCCESS = "UPDATE_STATUS_MARK_SUCCESS";
export const UPDATE_STATUS_MARK_FAIL = "UPDATE_STATUS_MARK_FAIL";


// For Getting State by stateId
export const GET_MARK_BY_ID = "GET_MARK_BY_ID";
export const GET_MARK_BY_ID_SUCCESS = "GET_MARK_BY_ID_SUCCESS";
export const GET_MARK_BY_ID_FAIL = "GET_MARK_BY_ID_FAIL";

// Upload all documents
export const UPLOAD_ALL_DOCUMENTS_MARK = "UPLOAD_ALL_DOCUMENTS_MARK";
export const UPLOAD_ALL_DOCUMENTS_MARK_SUCCESS =
  "UPLOAD_ALL_DOCUMENTS_MARK_SUCCESS";
export const UPLOAD_ALL_DOCUMENTS_MARK_FAIL = "UPLOAD_ALL_DOCUMENTS_MARK_FAIL";

export const GET_ALL_MARK_WITHOUT_FILTER = "GET_ALL_MARK_WITHOUT_FILTER";
export const GET_ALL_MARK_WITHOUT_FILTER_SUCCESS =
  "GET_ALL_MARK_WITHOUT_FILTER_SUCCESS";
export const GET_ALL_MARK_WITHOUT_FILTER_FAIL =
  "GET_ALL_MARK_WITHOUT_FILTER_FAIL";

export const GET_ALL_FACTORY = "GET_ALL_FACTORY";
export const GET_ALL_FACTORY_SUCCESS = "GET_ALL_FACTORY_SUCCESS";
export const GET_ALL_FACTORY_FAIL = "GET_ALL_FACTORY_FAIL";

export const CREATE_EDIT_API_STATUS_MARK = "CREATE_EDIT_API_STATUS_MARK";

export const FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID =
  "FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID";
export const FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID_SUCCESS =
  "FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID_SUCCESS";
export const FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID_FAILURE =
  "FETCH_MARK_DETAILS_BY_AUCTION_CENTER_ID_FAILURE";

export const API_DATA_MARK = "API_DATA_MARK";
export const DISABLE_MARK = "DISABLE_MARK";

export const DISABLE_SUBMIT_BUTTON = 'DISABLE_SUBMIT_BUTTON'
export const ENABLE_SUBMIT_BUTTON = 'ENABLE_SUBMIT_BUTTON'
